export const formsApiConfig = {
	apiVersion: "v1",
};
